export const findParentCollection = (component, opts) => {
  const dataTable = component.closestType('data-table');
  const dataGroup = component.closestType('data-group');
  let parentCollectionName = '';
  if (dataTable) {
    parentCollectionName = dataTable.get('collectionName');
  } else if (dataGroup) {
    parentCollectionName = dataGroup.get('collectionName');
  }
  if (!parentCollectionName) {
    if (opts) {
      if (opts.bindCollectionOptions) {
        let { collection } = opts.bindCollectionOptions;
        if (!collection) {
          collection = opts.snippetCollectionTraitOptions
            ? opts.snippetCollectionTraitOptions.collection
            : '';
        }
        if (collection) {
          parentCollectionName = collection.collectionId;
        }
      }
    }
  }
  return parentCollectionName;
};

export const findDetailsComponentCollection = (component, snippetType, pageCollection) => {
  const dataTable = component.closestType('data-table');
  const dataGroup = component.closestType('data-group');
  let parentCollectionName,
    parentComponentType = '';
  if (dataTable) {
    parentCollectionName = dataTable.get('collectionName');
    parentComponentType = 'DATA_TABLE';
  } else if (dataGroup) {
    parentCollectionName = dataGroup.get('collectionName');
    parentComponentType = 'DATA_GROUP';
  } else if (snippetType === 'SUB_PAGE') {
    parentCollectionName =
      pageCollection && pageCollection.collectionId ? pageCollection.collectionId : '';
    parentComponentType = snippetType;
  } else if (snippetType === 'MODAL') {
    parentCollectionName =
      pageCollection && pageCollection.collectionId ? pageCollection.collectionId : '';
    parentComponentType = snippetType;
  }
  return { parentCollectionName, parentComponentType };
};
